import React, {useEffect, useRef, useState} from "react";
import $ from "jquery";
import MySwitchButton from "../button/switch-button/SwitchButton";
import MyGroupSwitchButton from "../button/switch-button/GroupSwitchButton";
import * as omnimap from "../../../api/omnimap/omnimapActions";

export default function AdvancedSearch(props) {
    const [isFilterEverOpened, setIsFilterEverOpened] = useState(false)
    const [activeFilters, setActiveFilters] = useState([])
    const [searchKey, setSearchKey] = useState()
    const [searchAlert, setSearchAlert] = useState(false)
    const [conjunction, setConjunction] = useState('AND')

    useEffect(() => {
        if (isFilterEverOpened && activeFilters.length === 0) {
            handleSearch(true)
        }
    }, [activeFilters]);

    useEffect(() => {
        if (props.triggerOpen !== undefined) {
            $('#advanced-search-modal').modal('show')
            setIsFilterEverOpened(true)
        }
    }, [props.triggerOpen]);

    let selectedSwitchButton = useRef({
        item: undefined,
        index: undefined
    })

    function handleAddFilter() {
        if (!searchKey) {
            setSearchAlert(true)
            return
        }
        setActiveFilters([...activeFilters, {
            'searchKey': searchKey,
            'conjunction': conjunction,
            'selectedButton': selectedSwitchButton.current,
            'datatype': ""
        }])
    }

    function handleSwitchButton(item, index) {
        selectedSwitchButton.current = {
            item: {...item},
            index: index
        }
    }

    function handleClearFilter(index) {
        const _activeFilters = [...activeFilters]
        _activeFilters.splice(index, 1)
        setActiveFilters(_activeFilters)
    }

    function handleSearch(isFilterClearCall) {

        const model = {
            "content": [],
            "definitions": [...props.searchDefinitions],
            "text_search": []
        }

        if (!isFilterClearCall) {
            for (const filter of activeFilters) {
                model.content.push({
                    and_or: filter.conjunction,
                    key: filter.selectedButton.item.key,
                    datatype: filter.selectedButton.item.extra,
                    values: [ ] // Use here to search exact search
                })

                model.text_search.push({
                    and_or: filter.conjunction,
                    text_query: filter.searchKey,
                    search_fields: [
                        "IDENTIFIER",
                        "STATUS",
                        "CONTENT",
                        "NAME",
                        "IDENTIFICATION"
                    ],
                    fuzzy: true,
                })


            }
            if (props.indicatorClasses) {
                $('.' + props.indicatorClasses[0]).addClass(props.indicatorClasses[1])
            }
        } else {
            if (props.indicatorClasses) {
                $('.' + props.indicatorClasses[0]).removeClass(props.indicatorClasses[1])
            }
        }

        omnimap
            .GetAllBySearchAction(model, 100, 1)
            .then((result) => {
                typeof props.resultCallback === 'function' ? props.resultCallback({
                    'result': result,
                    'filters': activeFilters
                }) : void 0
                if (!isFilterClearCall) {
                    $('#advanced-search-modal').modal('hide')
                }
            });
    }

    function clearActiveFilters() {
        setActiveFilters([])
    }

    return (
        <div
            className="modal fade"
            tabIndex={-1}
            role="dialog"
            id="advanced-search-modal"

        >
            <div className="modal-dialog" role="document" style={{height: "1000px"}}>
                <div className="modal-content modal-tall">
                    <div className="modal-header">
                        <h5 className="modal-title">Geavanceerd zoeken</h5>
                        <button
                            type="button"
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        />
                    </div>
                    <div className="modal-body">
                        <label style={{marginLeft: '5px'}}>
                            Zoeksleutel
                        </label>

                        <div>
                            <input
                                id="search-field"
                                className={"advanced-search-field " + (searchAlert ? "red-hint" : "")}
                                type="input"
                                placeholder="Typ zoeksleutel"
                                onInput={(e: any) => {
                                    setSearchKey(e.target.value)
                                    setSearchAlert(false)
                                }}
                            />

                            <MySwitchButton
                                style={{
                                    width: "120px",
                                    float: "right",
                                }}
                                initialText={"AND"}
                                selectedText={"OR"}
                                onToggleState={(state) => {
                                    setConjunction(state ? 'AND' : 'OR')
                                }}
                                // turnOff={(off)=>{
                                //     window.$mm_setShowSelectedButtonOff = () => {
                                //         window.$mm_setShowSelectedButtonToggleState = false;
                                //         off();
                                //     }
                                // }}
                            />
                        </div>

                        <br/>
                        <br/>

                        <label style={{marginLeft: '5px'}}>
                            Doorzoekbaar veld
                        </label>
                        <div
                            className="searchable-fields container-box"
                        >
                            <MyGroupSwitchButton
                                count={2}
                                onSwitch={
                                    handleSwitchButton
                                }
                                selectedIndex={0}
                                texts={props.columns}
                            />
                        </div>

                        <br/>
                        <div className='container-box' style={{border: 'none', minHeight: 0}}>
                            {}
                            <button
                                type="button"
                                id="advanced-search-add-filter"
                                className="add-button ripple"

                                onClick={handleAddFilter}
                            >
                                Filter Toevoegen
                            </button>
                        </div>


                        <br/>
                        <br/>

                        <div>
                            <label style={{marginLeft: '5px'}}>Actieve filters</label>
                            <button
                                type="button"
                                id="advanced-search-submit"
                                className="clear-filter"
                                style={{
                                    float: "right"
                                }}
                                hidden={!activeFilters.length}
                                onClick={() => clearActiveFilters()}
                            >
                                Verwijder filter
                            </button>
                        </div>

                        <div
                            className="filter container-box"
                        >
                            {
                                activeFilters.map((item, index) =>
                                    <div className="space-label" id={activeFilters.length}
                                         onClick={() => handleClearFilter(index)}>
                                        <label className='and'>
                                            {item.conjunction}
                                        </label>
                                        <label>
                                            {item.searchKey}
                                        </label>
                                        <label>
                                            {item.selectedButton.item.value}
                                        </label>
                                    </div>
                                )
                            }
                        </div>


                        <br/>
                        <br/>
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            id="advanced-search-submit"
                            className="btn-modal"
                            style={{
                                width: "200px"
                            }}
                            onClick={() => handleSearch()}
                            disabled={!activeFilters.length}
                        >
                            Zoekopdracht
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );

};
